var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottomNavStoreTrue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.22477 8.09513C1.17045 6.9545 2.08058 6 3.2225 6H25.0275C26.1694 6 27.0795 6.9545 27.0252 8.09513L26.3064 23.1903C26.2049 25.323 24.4461 27 22.3109 27H5.93906C3.80389 27 2.04514 25.323 1.94358 23.1903L1.22477 8.09513Z",
    fill: "#004FEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.125 7C9.125 4.23858 11.3636 2 14.125 2C16.8864 2 19.125 4.23858 19.125 7",
    stroke: "#004FEC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.125 11C19.125 13.7614 16.8864 16 14.125 16C11.3636 16 9.125 13.7614 9.125 11",
    stroke: "white",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomNavStoreTrue);
export default __webpack_public_path__ + "static/media/bottom_nav_store_true.9c1777e1d082eda19f2b19db519abceb.svg";
export { ForwardRef as ReactComponent };